import axios from "axios";
import store from "@/store";
import notify from "@/utils/notify";

const instance = axios.create({
    // baseURL:process.env.VUE_APP_BACK_URL ?? "http://198.244.200.15:8003/api",
    baseURL:process.env.VUE_APP_BACK_URL ?? "https://app.denonciation.bj:8003/api",
    // baseURL:process.env.VUE_APP_BACK_URL ?? "http://172.21.10.1:8002/api",
});

export const SERVER_FILE = process.env.VUE_APP_FILE_SERVER_URL ?? "http://10.205.0.90:8080/uploads/tmp-recordings"

// Alter defaults after instance has been created

export default function ({ method = 'GET', url = "", data = [], mulitpart = false, client = false,params={} }) {
    let token = localStorage.getItem("token")
    let dataApi = data;
    if (client) {
        dataApi = {
            ...data, 
            grant_type: "password",
            client_id: process.env.VUE_APP_CLIENT_ID ?? null,
            client_secret: process.env.VUE_APP_CLIENT_SECRET ?? null,
        }
    }

    return new Promise((resolve, reject) => {
        instance({
            method,
            url,
            data:dataApi,
            params,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": mulitpart ? 'multipart/form-data' : 'application/json'
            }
        }).then((res) => {
            return resolve(res);
        }).catch((err) => {
            if (err.response?.status == 401 ) {
                // Vérifier si c'est une expiration de token
                const message = err.response?.data?.error || err.response?.data?.message || ''
                const isTokenExpired = message.toLowerCase().includes('expir') ||
                                    err.response?.data?.error === 'Token expiré'

                if (isTokenExpired) {
                    // Token expiré - afficher un message spécifique
                    notify("Votre session a expiré. Veuillez vous reconnecter.", "error")
                    localStorage.removeItem('token') // Supprimer le token expiré
                    setTimeout(() => {
                        window.location.href = '/login'
                    }, 2000)
                } else {
                    // Autre erreur 401 - déconnexion normale
                    store.dispatch("auth/user/logoutUser", null, { root: true })
                }
            }
            // Gérer le 403 Forbidden - Accès non autorisé
            if (err.response?.status == 403) {
                // Afficher un message d'erreur toast
                const errorMessage = err.response?.data?.error || "Accès non autorisé à cette ressource"
                notify(errorMessage, "error")

                // Rediriger SEULEMENT si on est sur une page de détail de dossier
                // Éviter la redirection pour les autres modules (users, etc.)
                const currentPath = window.location.pathname
                const isDossierDetailPage = /\/dossier\/\d+\/show/.test(currentPath)

                if (isDossierDetailPage) {
                    setTimeout(() => {
                        window.location.href = '/dossier/liste/all'
                    }, 1500) // Attendre 1.5s pour que le toast soit visible
                }
            }
            reject(err)
        })
    });
}
export function fetchNoAuth({ method = 'POST', url = "", data = [], }) {
    return instance({
        method,
        url,
        data
    });
}
